console.log("App Ext :1.637")
var scrollEnable = false;

setTimeout(() => {
  scrollEnable = true;
}, 12000);

var poweredByClientDisableList = []

if(poweredByClientDisableList.length>0){
  var searchEles = document.getElementById("tangent-iframe-div").getElementsByTagName('p');
  var current_shop_name = document.getElementById("tangent-shop-name").innerHTML;
  for(var pc=0; pc<poweredByClientDisableList.length; pc++){
    if(current_shop_name==poweredByClientDisableList[pc]){
      if(searchEles.length>0){
        for(var s=0; s<searchEles.length; s++){
          searchEles[s].classList.add("tangent-hide-element");
        }
      }
    }
  }
}

function bindEvent(element, eventName, eventHandler) {
  if (element.addEventListener){
    element.addEventListener(eventName, eventHandler, false);
  } else if (element.attachEvent) {
    element.attachEvent('on' + eventName, eventHandler);
  }
}
function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
// Listen to message from child window
bindEvent(window, 'message', function (e) {
  var objState = isJsonString(e.data);
  if(objState){
    var obj = JSON.parse(e.data);
    if(obj.quiz_type=="inline"){
      // UPDATED SCROLL-TO & IFRAME HEIGHT_SETTER
      switch (obj.type){
        case 'page':
            if(obj.key == 'scrollTop'){
              if(scrollEnable){
                var element = document.getElementById('tangent-block-quiz-iframe');
                var headerOffset = 145;
                var elementPosition = element.getBoundingClientRect().top;
                var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    
                window.scrollTo({
                  top: offsetPosition,
                  behavior: "smooth"
                });
              }
            }

            if(obj.key == 'iframe-height'){
                var height =  obj.value+ 150;
              
                var ex_height = document.getElementById("tangent-block-quiz-iframe").style.height;
                if(height != ex_height){
                  document.getElementById("tangent-block-quiz-iframe").setAttribute("style","min-height:"+ height+"px;width:100%");
                }
            }
          
          break;
    
        case 'number':
          var height =  e.data+ 150;
          var ex_height = document.getElementById("tangent-block-quiz-iframe").style.height;
          if(height != ex_height){
            document.getElementById("tangent-block-quiz-iframe").setAttribute("style","height:"+ height+"px;width:100%");
          }
          break;
        default:
    
          break;
      }
    }
  
  }

});